import { Button, Input, message, Modal, Popconfirm } from 'antd';
import React, { ChangeEvent, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { isEmpty, keys } from 'underscore';
import { IUTMItem, MarkerItem } from '../../typings/home';
import styles from './Style/ResultPanel.module.scss';
import { CoordinatesInfo } from './Component/CoordinatesInfo';
import { StoreContext } from '../../store/store';
import DownloadTab from './Component/DownloadTab';
import { Collapse } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import {
  DownloadInfoItem,
  IBestDataset,
  IPreviewAnalytic,
} from '../../typings/analytics';
import Api from '../../api/Api';
import { IDatasetBrief, KeyType } from '../../typings/metadata';
import { getNextFreeNumber, SEARCHPARAM } from '../Home/Component/Main/MainMap';
import { IBestDatasetRep } from '../../typings/searchdetailapi';
import { pointIsInCart } from '../PointHelper';
import { withLoading } from '../../components/Loading/withLoading';
import LoadingContext from '../../context/loadingContext/LoadingContext';
import { useUserProvider } from '../../generic/hooks';
import { useHistory } from 'react-router-dom';
import { ReactComponent as Validation } from '../../assets/icon/Validation.svg';
import { ReactComponent as Analysis } from '../../assets/icon/Analysis.svg';
import { ReactComponent as Report } from '../../assets/icon/Report.svg';
import { IPreprocessedAnalyticsPayload } from '../../typings/chart';
import { AnalyticsModal, DatasetOfflineModal, ReportsModal, ValidationModal } from './Component/DatasetModal';
import { useData } from './Store/DatasetContext';
import { DownloadCheckboxKey } from '../../generic/common';
import { DatasetRecord } from './Store/dataTypes';
import { DATASET_CATEGORIES } from '../../generic/filterBestDataset';
import { dateRangeLimit } from '../../generic/userGroupValidation';
import { DTFullFormat, TFormat } from '../../generic/StaticVariable';
import { ShoppingItem } from '../../typings/shopping';
import moment from 'moment';
import ValidationPanel from './Component/ValidationPanel';
import FeatureFlags from '../../feature-flags';

const Panel = Collapse.Panel;

export const getPointNamInCartError = (name: string) => {
  return (
    <>
      <div>
        {name + ' is already in the shopping cart.'}
        <div></div>
        {'Please rename the point or remove it from the cart.'}{' '}
      </div>
    </>
  );
};

export interface ResultPanelProps {
  isMark: boolean;
  open: boolean;
  children?: React.ReactNode;
  onMeshControl: (value: string) => any;
  addCoords: (coords: number[]) => void;
  onMark: (bool: boolean) => void;
  coordsMoved: boolean;
  onResetCoordsMove: () => void;
}

export default function ResultPanel(props: ResultPanelProps) {
  const {
    markerCollections,
    setMarkerCollections,
    shoppingItems,
    previewAnalytics,
    setPreviewAnalytics,
    datasetBriefs,
    setShowLayerView,
    setShowLogin,
    legend,
    setLegend,
    overridePointData,
    setShoppingItems,
    activeCategoryKey,
    setCloseValidation,
    fwePoints,
    cellSize,
    depth,
    userGroupPermissions,
    isAnalyticsVisible,
    setIsAnalyticsVisible,
    user
  } = useContext(StoreContext);
  const { state, dispatch } = useData();
  const loadingContext = useContext(LoadingContext);
  const history = useHistory()
  const [panelOpen, setPanelOpen] = useState<boolean>(false);
  const [nextFreePointNumber, setNextFreePointNumber] = useState('');
  const [activePanelKey, setActivePanelKey] = useState<string | string[]>('');
  const [
    isChangeCoordinatesWarningVisible,
    setIsChangeCoordinatesWarningVisible,
  ] = useState(false);
  const [UTMData, setUTMData] = useState<{ [key: string]: IUTMItem }>({});
  const [showUTM, setShowUTM] = useState(false)
  const [tempCoords, setTempCoords] = useState<number[] | null>(null);
  const [isAuthorized] = useUserProvider();
  const [hasDatasets, setHasDatasets] = useState(false);
  const [datasetIsOfflineWarningVisible, setDatasetIsOfflineWarningVisible] =
    useState(false);
  const [isReportsVisible, setIsReportsVisible] = useState(false);
  const [isValidationVisible, setIsValidationVisible] = useState(false);
  const [activePlotValidation, setActivePlotValidation] = useState<string[]>([
    'Altimeter Comparison',
  ]);
  const [datasetHeadline, setDatasetHeadline] = useState('');
  const activePoint = markerCollections.find((x) => x.active);
  const [resetCoordsKey, setResetCoordsKey] = useState('');
  const [updating, setUpdating] = useState(false);
  const [links, setLinks] = useState([]);
  const [error, setError] = useState('');
  const [loadingCart, setLoadingCart] = useState(false)
  const activeDataset = state.pointsMetadata[activePoint?.id ?? ''];

  const category = useMemo(() => {
    return  activePoint && activeCategoryKey?.[activePoint.id] ? activeCategoryKey[activePoint.id] : DownloadCheckboxKey.SW;
  }, [activeCategoryKey, activePoint])

  const activePointMetadata = useMemo(() => {
    const findActiveDataset = activePoint?.downloadPage.find((item) => item.radioKey === category)
    if (findActiveDataset && activeDataset?.datasets) {
      return activeDataset.datasets[findActiveDataset.datasetId]
    }
    return undefined
  }, [category, activeDataset?.datasets, activePoint])

  const handleVisibleAnalitycs = (value : boolean) => {
    if(activePoint){
      setIsAnalyticsVisible(((prevState: { [key: string]: string | string[] }) => ({
        ...prevState,
        [activePoint.id]: value
      })))
    }
  }

  const handleChangeUTMData = (index: string, item: IUTMItem) => {
    setUTMData(prevData => ({
      ...prevData,
      [index]: {
        east: item.east,
        north: item.north,
        zone: item.zone,
      }
    }));
  }

  async function onUpdatePreprocessedDataLink(
    payload: IPreprocessedAnalyticsPayload
  ) {
    try {
      setUpdating(true);
      const result = await Api.chart.getPreprocessedAnalytics(payload);
      if (result) {
        if (result.Result) {
          setError('');
          setLinks(result.Result);
        } else {
          setLinks([]);
          setError(
            result.Error && result.Error.ErrorMessage
              ? result.Error.ErrorMessage
              : 'Failed to return data'
          );
        }
      }
    } catch {
      setError('Failed to return data');
    } finally {
      setUpdating(false);
    }
  }

  const onShowReports = () => {
    if (!isAuthorized) {
      message.warn('You are not authorized to see reports');
      setShowLogin(true);
    } else {
      if (activePointMetadata && !activePointMetadata.isOffline) {
        setIsReportsVisible(true)
      } else {
        setDatasetIsOfflineWarningVisible(true)
      }
    }
  };

  const showAnalytics = () => {
    if (activePointMetadata && !activePointMetadata.isOffline && activePoint) {
      handleVisibleAnalitycs(true)
    } else {
      setDatasetIsOfflineWarningVisible(true)
    }
  };

  const showValidation = () => {
    if (!isAuthorized) {
      setShowLogin(true);
    } else {
      if (activePointMetadata && !activePointMetadata.isOffline) {
        setIsValidationVisible(true)
        setCloseValidation(false)
      } else {
        setDatasetIsOfflineWarningVisible(true)
      }
    }
  };

  async function doAddProductToCart(
    item: DownloadInfoItem,
    pointName: string,
    category: string,
    orderId: string,
    price: number,
    coordinates: number[]
  ) {
    if (item === null || !orderId) return Promise.resolve(false);

    if (!isEmpty(item)) {
      const start = moment(item?.dateRange[0]).format(TFormat);
      const end = moment(item?.dateRange[1]).format(TFormat);
      const meta = await Api.detail.searchDatasetDetail(item!.datasetId);

      if (meta) {
        const keyItems = keys((meta as any).g_items)
          .map((key) => key)
          .join('|');
        const checkoutDatasets = {
          datasetId: item!.datasetId,
          startDate: start,
          endDate: end,
          items: keyItems,
          coords: coordinates,
          orderId: orderId,
          pointName: pointName,
          category: category,
          price: price,
        };
        const response = await Api.shopping.AddShoppingCartItem_v2(
          checkoutDatasets
        );
        if (response.Error !== null) {
          // Could be "Error: This point name has already been used."
          // When logging in after point creation, point names of current session might
          // conflict with point names in shopping cart of previous sessions
          const errorMessage = response.Error.ErrorMessage
            ? response.Error.ErrorMessage
            : 'Failed to add the item to shopping cart';
          errorMessage === 'Error: This point name has already been used.'
            ? message.error(getPointNamInCartError(pointName))
            : message.warn(errorMessage);
          return Promise.resolve(false);
        }

        if (response.Result === 'OK') {
          const data = await Api.shopping.GetShoppingCart();
          setShoppingItems(data.shoppingItems);
          return Promise.resolve(true);
        }
      }
    }
    return Promise.resolve(false);
  }

  async function handleSingleDataset(
    item: (DatasetRecord & {
      label: string;
      coordinates: number[];
      categories: () => DATASET_CATEGORIES | '';
    }),
    shoppingItems: { [key: string]: { [key: string]: ShoppingItem } }
  ) {
    const {
      label,
      categories,
      metadata,
      coordinates,
      cellSize,
      depth,
      startDate,
      endDate
    } = item;
    const pointWithSameNameIsInCard = label in shoppingItems;

    if (pointWithSameNameIsInCard) {
      const itemsPerPoint = shoppingItems[label];
      if (itemsPerPoint[categories()] !== undefined) {
        message.error(getPointNamInCartError(label));
        return setLoadingCart(false)
      }
    }
    let [startTime, endTime] = dateRangeLimit(metadata.TimeDefinition.split(';'));
    if (startDate && endDate) {
      startTime = moment(startDate)
      endTime = moment(endDate)
    }

    try {
      const extractSubset = await Api.service.createSubsetExtractionTask(
        metadata.DatasetId,
        startTime.format(DTFullFormat),
        endTime.format(DTFullFormat),
        coordinates,
        label,
        cellSize!.toString(),
        depth!.toString(),
        datasetBriefs,
        fwePoints,
      );
      if (
        extractSubset &&
        extractSubset.Result &&
        extractSubset.Result.OrderIdList &&
        extractSubset.Result.OrderIdList.length > 0
      ) {
        const payloadAddProductItem: DownloadInfoItem = {
          datasetId: item.metadata.DatasetId,
          dateRange: [startTime, endTime],
          options: item.bestDataset!,
          radioKey: item.radioKey!

        }
        await doAddProductToCart(
          payloadAddProductItem,
          item.label,
          item.categories(),
          extractSubset.Result.OrderIdList[0],
          item.price!,
          item.coordinates
        );
      } else {
        message.error('Failed to prepare data');
      }
    } catch (error) {
      console.error(`Error while extracting subset for ${label}`, error);
    }
  }

  const handleAllToCart = useCallback(async () => {
    if (!isAuthorized) {
      setShowLogin(true);
      return;
    }

    const pointsMetadata = [{
      id: activePoint?.id,
      label: activeDataset.label,
      coordinates: markerCollections.find((item) =>item.label === activeDataset.label)?.coordinates ?? [],
      datasets:
        Object.keys(activeDataset.datasets).map((key) => {
          return {
            id: key,
            ...activeDataset.datasets[key]
          };
        })
    }]

    const allSelectedDataset = pointsMetadata.reduce((
      acc: (DatasetRecord & {
        label: string,
        coordinates: number[],
        categories: () => DATASET_CATEGORIES | ''
      })[], item) => {
      const filteredDatasets = item.datasets
        .map((dataset) => {
          return {
            ...dataset,
            label: item.label,
            coordinates: item.coordinates,
            categories: () => {
              switch (dataset.radioKey) {
                case DownloadCheckboxKey.SW:
                  return DATASET_CATEGORIES.WAVES
                case DownloadCheckboxKey.HD:
                  return DATASET_CATEGORIES.OCEAN
                case DownloadCheckboxKey.Wind:
                  return DATASET_CATEGORIES.ATMOSPHERE
                default:
                  return ''
              }
            }
          };
        });

      return acc.concat(filteredDatasets);
    }, []);

    try {
      setLoadingCart(true)
      await Promise.all(allSelectedDataset.map((item) => handleSingleDataset(item, shoppingItems)));
    } finally {
      setLoadingCart(false)
    }
  }, [isAuthorized, state.pointsMetadata, markerCollections, category, shoppingItems]);

  useEffect(() => {
    dispatch({ type: 'SET_POINT_ID', payload: { id: activePoint?.id! } });

    const hasDatasets = activePoint?.downloadPage?.some(page => page?.options?.length > 0) ?? false;
    setHasDatasets(hasDatasets);
  }, [activePointMetadata?.metadata?.DatasetId, activePoint?.downloadPage]);

  useEffect(() => {
    setPanelOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (props.coordsMoved && activePoint && activePoint.coordinatesToMove) {
      const inCart = pointIsInCart(activePoint, shoppingItems);
      if (inCart) {
        message.info('You cannot move a point that is already in the cart.');
        props.onResetCoordsMove();
      } else {
        onChangePointLocation(activePoint.coordinatesToMove);
      }
    }
  }, [props.coordsMoved, props.onResetCoordsMove, activePoint, shoppingItems]);

  useEffect(() => {
    if (props.isMark) {
      const next = getNextFreeNumber(markerCollections, shoppingItems);
      setNextFreePointNumber(next);
      setActivePanelKey(next);
    } else {
      if (activePoint !== undefined) {
        setActivePanelKey(activePoint.id);
      } else {
        setActivePanelKey('');
      }
    }
  }, [props.isMark, activePoint, markerCollections, shoppingItems]);

  const areDatasetsAvailable = async (
    coordinates: number[],
    showPartlyMissingDatasetsWarning: boolean
  ) => {
    return withLoading(
      async () => {
        setLegend({ ...legend, display: false });
        const datasetRep = await Api.detail.getBestDatasets(coordinates);
        if (!datasetRep) {
          message.warn('Waves, Ocean and Wind dataset is not found!');
          return null;
        }

        const missingDataset: string[] = new Array<string>();
        if (isEmpty(datasetRep.SW) || datasetRep.SW.length < 1) {
          missingDataset.push('Waves');
        }
        if (isEmpty(datasetRep.HD) || datasetRep.HD.length < 1) {
          missingDataset.push('Ocean');
        }
        if (isEmpty(datasetRep.Wind) || datasetRep.Wind.length < 1) {
          missingDataset.push('Wind');
        }
        if (showPartlyMissingDatasetsWarning && missingDataset.length > 0) {
          const errorMessage =
            missingDataset.length === 1
              ? missingDataset[0]
              : missingDataset.length === 2
                ? missingDataset[0] + ' and ' + missingDataset[1]
                : missingDataset[0] +
                ', ' +
                missingDataset[1] +
                ' and ' +
                missingDataset[2];
          message.warn(errorMessage + ' dataset is not found!');
        }
        if (missingDataset.length === 3) {
          return null;
        }

        return datasetRep;
      },
      loadingContext,
      { source: 'areDatasetsAvailable' }
    );
  };

  function generateDatasetOptions(
    datasetBriefs: IDatasetBrief[],
    datasetIds: string[]
  ) {
    const result: IBestDataset[] = [];
    datasetIds.forEach((id) => {
      const brief = datasetBriefs.find((b) => b.Id === id);
      if (brief !== undefined) {
        const obj: IBestDataset = {
          label: brief.IsFWE ? brief.Title : brief.ShortDescription,
          value: brief.Acronym,
          id: id,
        };

        result.push(obj);
      }

    });

    return result;
  }

  function updateActivePoint(
    bestDatasets: IBestDatasetRep,
    coordinates: number[]
  ) {
    if (activePoint !== undefined) {
      if (props.coordsMoved) {
        dispatch({ type: 'DELETE_GROUP', payload: { pointId: activePoint.id } })
      }
      setLegend({ ...legend, display: false });
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('coor', JSON.stringify(coordinates));
      history.push(`/?${searchParams.toString()}`);
      const datasetDefaultParams = {
        SW: searchParams.get('SW') ?? '',
        HD: searchParams.get('HD') ?? '',
        Wind: searchParams.get('Wind') ?? ''
      }
      activePoint.coordinates = coordinates;
      activePoint.allDataset = bestDatasets;
      activePoint.downloadPage!.forEach((item: DownloadInfoItem) => {
        const options = generateDatasetOptions(
          datasetBriefs,
          activePoint!.allDataset![item.radioKey]
        );
        item.options = options;
        if (!(!overridePointData && item.datasetId && bestDatasets[item.radioKey].includes(item.datasetId))) {
          item.datasetId = bestDatasets[item.radioKey + '_Default'].toString();
          const paramId = datasetDefaultParams[item.radioKey as KeyType]
          if (paramId) {
            const isFound = item.options.find((item) => item.id === paramId)
            if (isFound) {
              item.datasetId = paramId
            }
          }
        }
      });
      const downloadPage = activePoint.downloadPage.find(
        (item) => item.datasetId !== ''
      );
      activePoint.dataset =
        downloadPage !== undefined ? downloadPage.datasetId : '';

      setMarkerCollections([...markerCollections]);

      if (activePoint.ctrlValue.meshEnable) {
        props.onMeshControl(activePoint.dataset);
      } else props.onMeshControl('');

      props.onMark(false);
      setShowLayerView(true);
    }
  }

  useEffect(() => {
    (async function anyNameFunction() {
      if (datasetBriefs && datasetBriefs.length > 0 && activePoint && activePoint.coordinates) {
        const bestDatasets = await areDatasetsAvailable(
          activePoint.coordinates,
          false
        );
        bestDatasets &&
          updateActivePoint(bestDatasets, activePoint.coordinates);
      }
    })();
  }, [activePoint, datasetBriefs]);

  const handleChangeCoordinatesWarningOk = async () => {
    setIsChangeCoordinatesWarningVisible(false);
    if (tempCoords && activePoint !== undefined) {
      const bestDatasets = await areDatasetsAvailable(tempCoords, true);
      if (bestDatasets) {
        // before we change the coordinates, we need to release related previews from context
        const without = previewAnalytics.filter(
          (pa: IPreviewAnalytic) =>
            pa.coordinates.join() !== activePoint?.coordinates.join()
        );
        setPreviewAnalytics(without);
        setTempCoords(null);
        updateActivePoint(bestDatasets, tempCoords);
      } else {
        // We need to trigger the CoordinateInfo component to reset the active point's coordinates
        activePoint && setResetCoordsKey(activePoint.label);
      }
    }
  };

  const handleChangeCoordinatesWarningCancel = () => {
    setTempCoords(null);
    setIsChangeCoordinatesWarningVisible(false);
    activePoint && setResetCoordsKey(activePoint.label);
  };

  // do , when markerPoint location is changed
  async function onChangePointLocation(coords: number[], forceChange?: boolean) {
    setResetCoordsKey('');
    props.coordsMoved && props.onResetCoordsMove();
    // Before we change coordinates, we need to check if preview analytics have been created already
    const usedInPreview = previewAnalytics.find(
      (pa: IPreviewAnalytic) =>
        pa.coordinates.join() === activePoint?.coordinates.join()
    );
    if (usedInPreview !== undefined && !forceChange) {
      setTempCoords(coords);
      setIsChangeCoordinatesWarningVisible(true);
    } else {
      // If not used in preview, coordinates can be changed immediately but
      // we need to check if datasets are available for given coordinates
      const bestDatasets = await areDatasetsAvailable(coords, true);
      if (bestDatasets) {
        updateActivePoint(bestDatasets, coords);
      } else {
        // We need to trigger the CoordinateInfo component to reset the active point's coordinates
        !props.coordsMoved &&
          activePoint &&
          setResetCoordsKey(activePoint.label);
      }
    }
  }

  function onChangeActiveKey(key: string | string[]) {
    const point = markerCollections.find((x) => x.id === key);
    const datasetIdParams = {
      SW: '',
      HD: '',
      Wind: '',
    }
    point?.downloadPage.forEach((item) => {
      datasetIdParams[item.radioKey as KeyType] = item.datasetId
    })

    const searchParams = new URLSearchParams(location.search);

    if(!point) {
      searchParams.delete(SEARCHPARAM.COOR);
      searchParams.delete(SEARCHPARAM.SW);
      searchParams.delete(SEARCHPARAM.HD);
      searchParams.delete(SEARCHPARAM.WIND);
    }

    if (point !== undefined) {
      const coorEncoded = encodeURIComponent(JSON.stringify(point.coordinates)).trim();
      const SWEncoded = encodeURIComponent(datasetIdParams.SW).trim();
      const HDEncoded = encodeURIComponent(datasetIdParams.HD).trim();
      const WindEncoded = encodeURIComponent(datasetIdParams.Wind).trim();
      searchParams.set(SEARCHPARAM.COOR, coorEncoded);
      searchParams.set(SEARCHPARAM.SW, SWEncoded);
      searchParams.set(SEARCHPARAM.HD, HDEncoded);
      searchParams.set(SEARCHPARAM.WIND, WindEncoded);
      if (point.fwePointName) {
        const fwePointNameEncoded = encodeURIComponent(point.fwePointName).trim()
        searchParams.set(SEARCHPARAM.FWEPOINTNAME, fwePointNameEncoded)
      }
      markerCollections.map((point) => (point.active = false));
      point.active = true;
      setMarkerCollections([...markerCollections]);
    }
    history.push(`/?${searchParams.toString()}`);
    setActivePanelKey(key);
  }

  const getPointNameExistsError = (name: string) => {
    return (
      <>
        <div>
          {name + ' is already in use.'}
          <div></div>
          {'Please enter a different name'}{' '}
        </div>
      </>
    );
  };


  // !! delete point
  function onPointsDelete(id: string) {
    const index = markerCollections.findIndex((m) => m.id === id);
    if (index > -1) {
      setCloseValidation(true)
      dispatch({ type: 'DELETE_GROUP', payload: { pointId: id } })
      setIsValidationVisible(false)
      markerCollections.splice(index, 1);
      setMarkerCollections([...markerCollections]);
    }
  }

  // change point name
  function onPointNameChange(event: ChangeEvent<HTMLInputElement>, id: string) {
    const label = event.target.value;
    event.stopPropagation();
    const selected = markerCollections.find((m) => m.id === id);
    if (!selected) return;
    const exists = markerCollections.find((m) => m.label === label);
    if (exists) {
      message.error(getPointNameExistsError(label));
    } else {
      if (isAuthorized && Object.keys(shoppingItems).includes(label)) {
        message.error(getPointNamInCartError(label));
      } else {
        selected.label = label;
        dispatch({
          type: 'SET_LABEL', payload: {
            pointId: activePoint?.id!,
            label: label,
          }
        });
        setMarkerCollections([...markerCollections]);
      }
    }
  }

      // Only allow alphanumeric characters that work in filenames
      const validateInput = (event: ChangeEvent<HTMLInputElement>) => {
        const label = event.target.value;
        event.stopPropagation();
        const specialCharRegex = new RegExp(/[^a-zA-Z0-9.,_ ()-]/g);
        if (specialCharRegex.test(label)) {
          return false;
        }
        return true;
      };

  const pointActions = (
    index: string,
    markerPoint: MarkerItem | undefined,
    editable: boolean,
    addCoords: (coords: number[]) => void,
    pointIsInCard: boolean
  ) => {
    const prefix =
      markerPoint === undefined
        ? ''
        : markerPoint.active
          ? 'Active:'
          : 'Activate:';
    return markerPoint === undefined ? (
      <div>
        <CoordinatesInfo
          key={index}
          index={index}
          name={''}
          x={null}
          y={null}
          changeCoords={onChangePointLocation}
          addCoords={addCoords}
          disableCoordinateChange={pointIsInCard}
          resetCoordsKey={resetCoordsKey}
          UTMItem={UTMData[index]}
          setUTMItem={(item) => handleChangeUTMData(index, item)}
          showUTM={showUTM}
          setShowUTM={setShowUTM}
          onPointNameChange={onPointNameChange}
          onPointsDelete={onPointsDelete}
          markerPoint={markerPoint}
          onMark={props.onMark}
        />
      </div>
    ) : editable  ? (markerPoint.active ? (
      <div onClick={e => e.stopPropagation()}>
        <CoordinatesInfo
          index={index}
          key={markerPoint ? markerPoint.id : index}
          name={markerPoint ? markerPoint.label : ''}
          x={
            markerPoint && markerPoint.coordinates.length > 1
              ? markerPoint!.coordinates[0]
              : null
          }
          y={
            markerPoint && markerPoint.coordinates.length > 1
              ? markerPoint!.coordinates[1]
              : null
          }
          changeCoords={onChangePointLocation}
          addCoords={addCoords}
          disableCoordinateChange={pointIsInCard}
          resetCoordsKey={resetCoordsKey}
          UTMItem={UTMData[index]}
          setUTMItem={(item) => handleChangeUTMData(index, item)}
          showUTM={showUTM}
          setShowUTM={setShowUTM}
          onPointNameChange={onPointNameChange}
          onPointsDelete={onPointsDelete}
          markerPoint={markerPoint}
        />
        </div>
    ) : (
      <div className={styles.pointActions + ' pointActions'}>
      <Input
        size="small"
        value={markerPoint ? markerPoint.label : 'P' + index}
        maxLength={25}
        onChange={(e) =>
          validateInput(e) &&
          onPointNameChange(e, markerPoint.id)
        }
        style={{ width: '25%' }}
      />
      {!showUTM && (
        <div style={{ marginLeft: '10px', display: 'flex' }}>
          <Input
            prefix={'Long: '}
            size="small"
            value={`${markerPoint.coordinates[0]}`}
            maxLength={10}
            disabled
            style={{ margin: '0 5px' }}
          />
          <Input
            prefix={'Lat: '}
            size="small"
            value={`${markerPoint.coordinates[1]}`}
            maxLength={10}
            disabled
            style={{ margin: '0 5px' }}
          />
        </div>
      )}
      {showUTM && (
        <div style={{ marginLeft: '10px', display: 'flex' }}>
          <Input
            prefix={'East: '}
            size="small"
            value={`${UTMData[index].east}`}
            maxLength={10}
            disabled
            style={{ margin: '0 2px' }}
          />
          <Input
            prefix={'North: '}
            size="small"
            value={`${UTMData[index].north}`}
            maxLength={10}
            disabled
            style={{ margin: '0 2px' }}
          />
          <Input
            prefix={'UTM Zone: '}
            size="small"
            value={`${UTMData[index].zone}`}
            maxLength={10}
            disabled
            style={{ margin: '0 2px' }}
          />
        </div>
      )}
      <Popconfirm
        placement="left"
        title={'Are you sure to delete this Point?'}
        onConfirm={() =>
          withLoading(() => onPointsDelete(markerPoint.id), loadingContext, {
            source: 'onPointsDelete',
          })
        }
        okText="Yes"
        cancelText="No"
      >
        <span onClick={(e) => e.stopPropagation()}>
          <DeleteOutlined className={styles.deleteIcon} />
        </span>
      </Popconfirm>
    </div>
    )) : (
      <div>{prefix + ' ' + markerPoint.label}</div>
    );
  };

  const panelForPoint = (
    index: string,
    addCoords: (coords: number[]) => void,
    onMeshControl: (value: string) => any,
    markerPoint?: MarkerItem
  ) => {
    let pointIsInCard = false;
    if (markerPoint) {
      const name = markerPoint.label;
      const pointWithSameNameIsInCard = markerPoint
        ? Object.keys(shoppingItems).includes(name)
        : false;
      if (pointWithSameNameIsInCard) {
        const itemsPerPoint = shoppingItems[name];
        const categories = Object.keys(itemsPerPoint);
        const firstCategory = itemsPerPoint[categories[0]];
        // Take also coordinates into account to allow editing of points with same name from previous sessions
        pointIsInCard =
          markerPoint.coordinates.join() ===
          firstCategory.location.replace(' ', '');
      }
    }

    return (
      <Panel
        className={`${styles.panel} ${markerPoint?.active ? 'markerSelected' : ''}`}
        header={pointActions(index, markerPoint, !pointIsInCard, addCoords, pointIsInCard)}
        key={index}
      >
        {!markerPoint || isEmpty(markerPoint!.coordinates) ? null : (
          <div className={styles.resultTabs}>
            <DownloadTab
              onAddProductToCart={doAddProductToCart}
              activePointId={activePoint?.id}
              list={markerPoint.downloadPage}
              coords={markerPoint.coordinates}
              onMeshControl={onMeshControl}
              setDatasetIsOfflineWarningVisible={setDatasetIsOfflineWarningVisible}
            ></DownloadTab>
          </div>
        )}
      </Panel>
    );
  };

  const activePointAnalyticsModal = useMemo(() => {
    const analyticsModal = markerCollections.map((point) => {
      const isTnw = point?.downloadPage[0]?.datasetId.toLowerCase().includes('tnw') && user.authenticated
      const cell = cellSize[category as string].toString()
      const waterDepth = depth[category as string].toString()
      return (
        <AnalyticsModal
          category={category}
          point={point}
          key={`analytics-modal-${point.id}`}
          activePoint={point}
          isAnalyticsVisible={isAnalyticsVisible[point.id]}
          setDatasetHeadline={setDatasetHeadline}
          setIsAnalyticsVisible={handleVisibleAnalitycs}
          setDatasetIsOfflineWarningVisible={setDatasetIsOfflineWarningVisible}
          userGroupPermissions={userGroupPermissions}
          onMeshControl={props.onMeshControl}
          isTnw={isTnw}
          gridCellSize={cell}
          waterDepth={waterDepth}
        />
      );
    })
    return analyticsModal
  }, [markerCollections, activePoint, isAnalyticsVisible])

  return (
    <>
       {isValidationVisible &&  <ValidationPanel
          onChangePointLocation={onChangePointLocation}
          isValidationVisible={isValidationVisible}
          setIsValidationVisible={setIsValidationVisible}
          setActivePlotValidation={setActivePlotValidation}
          setDatasetHeadline={setDatasetHeadline}
          activePoint={activePoint}
          activePointMetadata={activePointMetadata}
          activePlotValidation={activePlotValidation}
        />}
      <div className={`${styles.root} ${panelOpen ? styles.rootOpen : ''}`}>
        <DatasetOfflineModal datasetIsOfflineWarningVisible={datasetIsOfflineWarningVisible} handleCloseDatasetIsOfflineWarning={setDatasetIsOfflineWarningVisible} />
        <ReportsModal
          activePoint={activePoint}
          error={error}
          isReportsVisible={isReportsVisible}
          links={links}
          onUpdatePreprocessedDataLink={onUpdatePreprocessedDataLink}
          setIsReportsVisible={setIsReportsVisible}
          updating={updating}
        />
        {activePointAnalyticsModal}
        <Modal
          visible={isChangeCoordinatesWarningVisible}
          onOk={handleChangeCoordinatesWarningOk}
          onCancel={handleChangeCoordinatesWarningCancel}
        >
          <p>
            Changing the coordinates will reset your validation and analytics.
            Continue?
          </p>
        </Modal>
        <div>
            {hasDatasets && activePoint && !isEmpty(activePoint!.coordinates) && category && (
              <div className={styles.DatasetLabel}>
                <Button  className={styles.buttonBorder} type="default" onClick={showValidation}>
                  <div className={styles.buttonContent}>
                    <Validation width={30} height={30} viewBox={"0 0 40 40"} />
                    <div className={styles.buttonLabel}>Validation</div>
                  </div>
                </Button>

                <Button className={styles.buttonBorder} type="default" onClick={showAnalytics}>
                  <div className={styles.buttonContent}>
                    <Analysis width={30} height={30} viewBox={"0 0 40 40"} />
                    <div className={styles.buttonLabel}>Analytics</div>
                  </div>
                </Button>

                <Button className={styles.buttonBorder} disabled={!activePointMetadata?.hasReports}
                  type="default"
                  onClick={activePointMetadata?.hasReports
                    ? onShowReports : () => { }}
                    >
                    <div className={styles.buttonContent}>
                      <Report className={activePointMetadata?.hasReports ? '' : styles.buttonIconDisabled} width={30} height={30} viewBox={"0 0 40 40"}/>
                      <div className={activePointMetadata?.hasReports ? styles.buttonLabel : styles.buttonLabelDisabled}>Reports</div>
                    </div>

                </Button>
              </div>
            )}
          <Collapse
            accordion
            activeKey={activePanelKey}
            onChange={onChangeActiveKey}
          >
            {props.isMark &&
              panelForPoint(
                nextFreePointNumber,
                props.addCoords,
                props.onMeshControl
              )}
            {markerCollections.map((markerPoint: MarkerItem) =>
              panelForPoint(
                markerPoint.id,
                props.addCoords,
                props.onMeshControl,
                markerPoint
              )
            )}
          </Collapse>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}>
            <Button
              type='primary'
              loading={loadingCart}
              onClick={() => handleAllToCart()}
              disabled={!category}
              className={styles.cartButton}
            >
              Add all to cart
            </Button>
          </div>
        </div>
        {props.children}
      </div>
    </>
  );
}
